import PropTypes from 'prop-types';
import currencyExchangeProp from './currencyExchangeProp';

export const WALLET_TRANSACTION_TYPE = {
  PAYMENT: 'payment',
  PAYOUT: 'payout',
};

export const WALLET_TRANSACTION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

const propType = {
  _id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  transactionNumber: PropTypes.number.isRequired,
  transactionType: PropTypes.oneOf(Object.values(WALLET_TRANSACTION_TYPE))
    .isRequired,
  status: PropTypes.oneOf(Object.values(WALLET_TRANSACTION_STATUS)).isRequired,
  date: PropTypes.number.isRequired,
  amount: PropTypes.number,
  userPrice: PropTypes.shape(currencyExchangeProp.propType),
  newBalance: PropTypes.number,
  userPriceNewBalance: PropTypes.shape(currencyExchangeProp.propType),
  currencyInfo: PropTypes.shape(currencyExchangeProp.propType),
  createdAt: PropTypes.number.isRequired,
  updatedAt: PropTypes.number.isRequired,
};

export default { propType };
